__turbopack_context__.v({
  "bodyM": "styles-module-scss-module__ao_lOW__bodyM",
});
